<div class="body-indent">
  <!-- Search Box -->
  <div class="row">
    <div class="col-md-6 col-12 mb-3">
      <div class="search-bar-wrapper">
        <span class="search-icon">
          <i class="bi bi-search"></i>
        </span>
        <input
          type="text"
          class="search-input"
          [placeholder]="searchPlaceholder"
          [ngModel]="searchQuery"
          (ngModelChange)="onSearch($event)"
        />
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="action-row">
    <ng-container *ngIf="!isReordering; else reorderMode">
      <!-- If not reordering, show "Add" and "Reorder" -->
      <button type="button" class="petszel-primary-button" (click)="addClicked()">
        Add Document or Link
      </button>
      <button
        type="button"
        class="petszel-secondary-button"
        (click)="toggleReorder()"
        [disabled]="searchQuery"
        [title]="searchQuery ? 'Clear search filter before reordering' : ''"
      >
        Reorder
      </button>
    </ng-container>

    <ng-template #reorderMode>
      <div class="col-auto d-flex align-items-center">
        <a type="button" class="cancelBtn" (click)="cancelReorder()">
          Cancel
        </a>
      </div>
      <div class="col-auto">
        <button type="button" class="secondaryBtn" (click)="saveReorder()">
          Save
        </button>
      </div>
    </ng-template>
  </div>

  <div *ngIf="showPetszelWarning" class="petszel-warning mt-3" role="alert">
    After you upload your organization's packet be sure to delete the default
    Petszel Adoption Packet(s).
  </div>

  <!-- List Items (Documents/Links) -->
  <div
    cdkDropList
    [cdkDropListData]="filteredItems"
    (cdkDropListDropped)="drop($event)"
    [cdkDropListDisabled]="!isReordering"
    class="doc-list"
  >
    <div
      class="doc-row"
      [ngClass]="{
        reordering: isReordering,
        'link-item': isLink(item),
        'document-item': !isLink(item),
        'recently-moved': movedItemId === (item.id || 'index-' + i)
      }"
      *ngFor="let item of filteredItems; let i = index"
      cdkDrag
    >
      <!-- Drag handle icon to the left if isReordering -->
      <div *ngIf="isReordering" class="drag-handle" cdkDragHandle>
        <img
          src="../../../assets/images/sorting-bars.svg"
          alt="Sorting Bars"
          class="sorting-bars"
        />
      </div>

      <!-- Document or Link Type -->
      <div class="doc-info">
        <div class="doc-type">
          <span
            class="doc-type"
            [ngClass]="{
              'badge-link': isLink(item),
              'badge-document': !isLink(item)
            }"
          >
            {{ isLink(item) ? "Link" : "Document" }}
          </span>
        </div>
        <a
          *ngIf="item.blobUrl || item.url"
          [href]="item.blobUrl || item.url || '' | formatUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ item.name }}
        </a>
        <span *ngIf="!(item.blobUrl || item.url)">
          {{ item.name }}
        </span>
      </div>

      <!-- Category -->
      <div class="doc-category">
        <span class="label">Category</span>
        <span class="value">{{ item.docType || "—" }}</span>
      </div>

      <!-- Species -->
      <div class="doc-species">
        <span class="label">Species</span>
        <span class="value">{{ item.species || "All" }}</span>
      </div>

      <!-- Life Stage -->
      <!-- <div class="doc-lifestage">
        <span class="label">Life Stage</span>
        <span class="value">{{ getLifeStageLabel(item) || "All" }}</span>
      </div> -->

      <!-- Actions (only shown when not reordering) -->
      <div class="doc-actions" *ngIf="!isReordering">
        <button class="btn edit-btn" (click)="editClicked(item)"></button>
        <button
          class="btn delete-btn"
          (click)="deleteClicked(item, i)"
        ></button>
      </div>
    </div>
  </div>
</div>
